import React from "react";
import { useState, useEffect, useRef } from "react";
import axiosAuth from "../Axios/Interceptors";
import AppContext from "../Context/Context";
type Props = {
  TypeId: number;
  retailerScoreCardData: any;
};
function RetailerScorecardDetails(props: Props) {
  const [retailerScorecardDetailsData, setRetailerScorecardDetailsData] =
    useState([]);
  useEffect(() => {}, []);
  return (
    <div className="alignment-flex">
      {props.retailerScoreCardData &&
        props.retailerScoreCardData.map((Item: any,index:number) => (
          <div key={props.TypeId+index} className="detail-item-flex">
            <p>{Item.Name}</p>
            <span>{Item.FinalValueTextVal}</span>
            <span className={"ScoreCategory" + Item.ScoreType}>
              {Item.FinalPoints}
            </span>
          </div>
        ))}
    </div>
  );
}

export default RetailerScorecardDetails;
